import styled from '@emotion/styled'

export const SwitchWrapper = styled.div`
  display: inline-flex;
  position: relative;
`
